import React from 'react';
import PropTypes from 'prop-types';
import { useField, ErrorMessage, useFormikContext } from 'formik';
import classnames from 'classnames';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Chip from '@material-ui/core/Chip';

const Input = ({
  label,
  extra,
  max,
  min,
  icon,
  startIcon,
  type,
  onClickIcon,
  customValidation,
  params,
  isJson,
  defaultValue,
  options = [],
  ...props
}) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();

  const error = meta.touched && meta.error;
  return (
    <div className="input__container">
      {type === 'textarea' ? (
        <TextField
          className={classnames('text-input', {
            error,
            endIcon: icon,
            startIcon,
          })}
          maxLength={max}
          {...props}
          {...field}
          style={startIcon ? { paddingLeft: '40px' } : {}}
          label={label}
          multiline
          minRows={4}
          type={type}
          defaultValue={defaultValue}
          value={defaultValue ? undefined : field.value}
          inputProps={{ ...(props.inputProps || {}), maxLength: max }}
          disabled={props.disabled}
        />
      ) : type === 'datepicker' ? (
        <TextField
          className={classnames('text-input', {
            error,
            endIcon: icon,
            startIcon,
          })}
          {...field}
          style={startIcon ? { paddingLeft: '40px' } : {}}
          label={label}
          id="datetime-local"
          type="datetime-local"
          defaultValue={field.value}
          InputLabelProps={{ shrink: true }}
          inputProps={{ min }}
          {...props}
          disabled={props.disabled}
        />
      ) : type === 'multiselect' ? (
          <FormControl className="text-input" error={!!error} style={{ width: '100%' }}>
            <InputLabel>{label}</InputLabel>
            <Select
              multiple
              value={Array.isArray(field.value) ? field.value.map(v => v.value) : []}
              onChange={(e) => {
                // e.target.value es un array de strings (los value seleccionados)
                const selectedValues = e.target.value;
                // Mapea los values seleccionados a los objetos completos de options
                const selectedOptions = options.filter(opt => selectedValues.includes(opt.value));
                setFieldValue(field.name, selectedOptions);
              }}
              renderValue={(selected) => (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                  {options
                    .filter(opt => selected.includes(opt.value))
                    .map(opt => (
                      <Chip key={opt.value} label={opt.label} />
                    ))}
                </div>
              )}
              {...field}
              {...props}
            >
              {options.map((option) => (
                <MenuItem
                  key={option.value}
                  value={option.value}
                  selected={Array.isArray(field.value) && field.value.some((selectedItem) => selectedItem.value === option.value)}
                >
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
      ) : (
        <TextField
          className={classnames('text-input', {
            error,
            endIcon: icon,
            startIcon,
          })}
          maxLength={max}
          {...field}
          {...props}
          style={startIcon ? { paddingLeft: '40px' } : {}}
          label={label}
          type={type}
          name={props.name}
          value={field.value}
          onChange={(e) => {
            setFieldValue(field.name, e.target.value);
          }}
          inputProps={{ maxLength: max, min, max }}
          disabled={props.disabled}
        />
      )}

      {icon && (
        <span
          className={`input-icon end ${!onClickIcon ? !error && 'success' : ''}`}
          onClick={onClickIcon}
        >
          {icon}
        </span>
      )}

      {startIcon && <span className="input-icon start">{startIcon}</span>}

      {error && (
        <div className="error-message">
          {isJson ? (
            <p className="error-message" name={props.id || props.name}>
              {JSON.stringify(meta.error)}
            </p>
          ) : (
            <ErrorMessage className="error-message" name={props.id || props.name} />
          )}
        </div>
      )}

      {customValidation && (
        <div className="error-message">
          <p>{customValidation}</p>
        </div>
      )}

      {!meta.error && <p className="extra-message">{extra}</p>}
    </div>
  );
};

export default Input;
